export default __webpack_public_path__ + "d3ae0e9030731f16a2218da54c778565.woff2";